import whenDomReady from 'when-dom-ready';
import debugWidget from "./widget-debug.js";

let trackerCount = 0;
export default class {
  constructor(gaID, permalink, rootURL, uuid, options) {
    this.gaID = gaID;
    this.permalink = permalink;
    this.rootURL = rootURL;
    this.trackerName = `like2have${trackerCount++}`;

    let defaults = {
      env: 'production',
      disabled: false
    }

    let actuals = Object.assign({}, defaults, options);

    this.DEBUG = function(output) {
      debugWidget(output, uuid, this);
    }

    this.ENV = actuals.env;
    this.disabled = actuals.disabled;

    const t = this.ga();

    if (t != null) { t('create', this.gaID , {'name': this.trackerName, cookieDomain: 'auto'}); }
  }

  trackShopableClick(url, photoID) {
    this.DEBUG(`trackShopableClick  ${this.gaID} - ${url}, ${photoID}`);

    const promise = new Promise((resolve, reject) => {
      const t = this.ga();
      if (t != null) {
        if (t.hasOwnProperty('loaded') && (t.loaded === true)) {
          setTimeout(() => {
            this.DEBUG("resolving trackShoppableClick in timeout");
            return resolve();
          } , 1000);
          t(`${this.trackerName}.send`, 'event', 'l2h-outbound', `click|${this.permalink}`, url, {
            hitCallback: () => {
              this.DEBUG("resolving trackShoppableClick after GA callback");
              return resolve();
            }
          }
           );
        } else {
          this.DEBUG("resolving trackShoppableClick due to ga not loaded");
          resolve();
        }
      } else {
        this.DEBUG("resolving trackShoppableClick without GA");
        resolve();
      }
    });

    return promise;
  }

  //L2H DEBUG: trackModalView UA-57124214-1 - view|undefined|undefined -> http://localhost:3000/admin/photos/2463638
  trackModalView(imageID) {
    this.DEBUG(`trackModalView ${this.gaID} - view|${this.permalink} -> ${this.rootURL}admin/photos/${imageID}`);
    const t = this.ga();
    if (t != null) { return t(`${this.trackerName}.send`, 'event', 'l2h-modal', `view|${this.permalink}` , `${this.rootURL}admin/photos/${imageID}`); }
  }

  trackPageView() {
    this.DEBUG(`trackPageView ${this.gaID} - view|${this.permalink}`);
    const t = this.ga();

    whenDomReady().then(() => {
      if (t != null) { return t(`${this.trackerName}.send`, 'pageview'); }
    });
  }

  ga() {
    if (this.ENV !== "production") { return; }
    if (this.disabled) { return; }

    if (L2H.loadGoogleAnalytics && (typeof GoogleAnalyticsObject === 'undefined' || GoogleAnalyticsObject === null)) { L2H.loadGoogleAnalytics(); }
    this.DEBUG(`L2H DEBUG: GoogleAnalyticsObject is ${GoogleAnalyticsObject}`);

    if (L2H.googleAnalyticsLoaded) {
      return l2hga;
    } else {
      if (typeof GoogleAnalyticsObject !== 'undefined' && GoogleAnalyticsObject !== null) { return window[GoogleAnalyticsObject]; }
    }
  }

}
